import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 904px;

  > h1 {
    text-align: center;
  }
`;

export const WrapperButtons = styled.div`
  margin-bottom: 24px;
`;

export const Filter = styled.form`
  width: 100%;
  max-width: 720px;
  border-radius: 10px;
  border: 1px solid #9d9d9d;
  padding: 32px 12px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "dataIni" "dataFim" "buttons";
  gap: 32px 16px;
  margin-bottom: 24px;

  > :nth-child(1) {
    grid-area: dataIni;
  }

  > :nth-child(2) {
    grid-area: dataFim;
  }
  > :nth-child(3) {
    grid-area: buttons;
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  @media (min-width: 640px) {
    padding: 32px;

    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "dataIni dataFim buttons";

    > :nth-child(3) {
      grid-area: buttons;
      display: flex;
      justify-content: center;
      gap: 16px;
    }
  }
`;

export const ButtonSelect = styled.button`
  display: flex;
  width: 85px;
  height: 30px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #20332f;

  color: #fff;
  text-align: center;
  font-family: Mulish;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const Table = styled.div`
  margin-bottom: 32px;

  > div:nth-child(odd) {
    border-radius: 10px;
    background: #e8e8e8;
  }

  > div:nth-child(even) {
    border-radius: 10px;
    background: #f7f7f7;
  }

  > div + div {
    margin-top: 16px;
  }
`;

export const TableItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.2fr;
  padding: 16px;
  grid-template-areas: "data button" "cidade button" "vagas button";
  align-items: center;

  > :nth-child(1) {
    grid-area: cidade;
  }
  > :nth-child(2) {
    grid-area: data;
  }
  > :nth-child(3) {
    grid-area: vagas;
  }
  > :nth-child(4) {
    grid-area: button;
  }

  > p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    > span {
      color: #595959;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.36px;
    }
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 0.6fr 0.2fr;

    grid-template-areas: "cidade data vagas button";
    align-items: center;
    align-items: center;
    padding: 12px 8px;
  }
`;
